module.exports = __webpack_public_path__ + "media/boing.ac28dc3b.mp3";